import axios from './axios'
import config from './config.json'
const defaultError = (response, source) => {
	console.error(response, source)
}
const handleError = (e, callback, source) => {
	if(e.response && e.response.status && e.response.status == 401)
		logout()
	else
		callback(e, source)
}

export const logout = () => {
	window.localStorage.removeItem(config.tokenName)
	window.localStorage.removeItem(config.sessionName)
	window.localStorage.removeItem(config.userName)
	window.localStorage.removeItem(config.roleName)
	window.location.href = '/login'
}

export const citiesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.get('/address/cities')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "address/cities/list"))
	}
}

export const statesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.get('/address/states')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "address/states/list"))
	}
}

export const countriesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.get('/address/countries')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "address/countries/list"))
	}
}

export const metricsAPI = {
	products:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.get('/metrics/products')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "metrics/products"))
	}
}

export const storesAPI = {
	create:(store, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.post('/stores', store)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stores/create"))
	},
	update:(storeName, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.put('/stores/'+storeName, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stores/update"))
	},
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.get('/stores/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stores/list"))
	},
	delete:(storeName, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName)})
			.post('/stores/delete/'+storeName)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stores/delete"))
	},
}

export const warehousesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/warehouses/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "warehouses/list"))
	},
	create:(warehouse, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/warehouses', warehouse)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "warehouse/create"))
	},
	update:(scid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/warehouses/'+scid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "warehouse/update"))
	},
	delete:(scid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/warehouses/delete/'+scid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "warehouse/delete"))
	},
}

export const inventoriesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/inventories/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "inventories/list"))
	},
	create:(inventory, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/inventories', inventory)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "inventory/create"))
	},
	quantity:(scid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/inventories/quantity/'+scid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "inventory/update"))
	},
	update:(scid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/inventories/'+scid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "inventory/update"))
	},
	delete:(scid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/inventories/delete/'+scid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "inventory/delete"))
	},

	capital:(inventories, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/inventories/capital', inventories)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "inventories/capital"))
	}
}

export const salesChannelShippmentsAPI = {
	register:(packs, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/salesChannelShippments/', packs)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "salesChannelShippments/register"))
	}
}

export const productsAPI = {
	create:(product, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/products', product)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "product/create"))
	},
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/products/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/list"))
	},
	read: (id, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/products/'+id)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/detail"))
	},
	assignCurrency: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignCurrency', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignCurrency"))
	},
	assignClient: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignClient', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignClient"))
	},
	assignSupplier: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignSupplier', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignSupplier"))
	},
	productBulkUpdate:(cost, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/products/productBulkUpdate', cost)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/productBulkUpdate"))
	},
	assignDiscount: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignDiscount', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignDiscount"))
	},
	assignSeason: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignSeason', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignSeason"))
	},
	assignCost: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignCost', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignCost"))
	},
	assignDimensions: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/assignDimensions', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/assignDimensions"))
	},
	deleteProducts: (body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/products/deleteProducts', body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/deleteProducts"))
	},
	updateListings:(listings, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/products/updateListings', listings)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "products/updateListings"))
	}
}

export const vendorsAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/vendors/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "vendors/list"))
	},
}

export const suppliersAPI = {
	create:(client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/suppliers/', client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "suppliers/create"))
	},
	update:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/suppliers/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "suppliers/create"))
	},
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/suppliers/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "suppliers/list"))
	},
}
export const currenciesAPI = {
	create:(client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/currencies/', client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "currencies/create"))
	},
	update:(id, currency, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/currencies/'+id, currency)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "currencies/update"))
	},
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/currencies/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "currencies/list"))
	},
}

export const clientsAPI = {
	create:(client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/clients/', client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/create"))
	},
	update:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/clients/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/update"))
	},
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/clients/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/list"))
	},
	metrics:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/clients/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/metrics-toggle"))
	},
	externalwarehousing_detail:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/clients/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/externalwarehousing_detail-toggle"))
	},
	pick_and_pack:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/clients/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/pick_and_pack-toggle"))
	},
	factoring:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/clients/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/factoring-toggle"))
	},
	onlyEvents:(id, client, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/clients/'+id, client)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "clients/onlyEvents-toggle"))
	},
}

export const bundlesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/bundles/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "bundles/list"))
	},
	create:(bundle, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/bundles', bundle)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "bundle/create"))
	},
	update:(scid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/bundles/'+scid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "bundle/update"))
	},
	delete:(scid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/bundles/delete/'+scid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "bundles/delete"))
	},
}

export const platformstatusesAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/platform/statuses/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "platformstatus/list"))
	},
	create:(platformstatus, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/platform/statuses', platformstatus)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "platformstatus/create"))
	},
	update:(scid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/platform/statuses/'+scid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "platformstatus/update"))
	},
	delete:(scid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/platform/statuses/delete/'+scid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "platformstatuses/delete"))
	},
}

export const platformcostcalculationsAPI = {
	list: (callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/platform/costCalculations/')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "platformcostcalculations/list"))
	},
	upsert:(costCalculations, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/platform/costCalculations', costCalculations)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "platformcostcalculations/upsert"))
	},
}

export const liquidationsAPI = {
	create:(payments, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/liquidations/', payments)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "liquidations/create"))
	}
}

export const requisitionsAPI = {
	create:(stocks, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/requisitions/', stocks)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "requisitions/create"))
	},
	clientCreate:(cid, stocks, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/requisitions/'+cid, stocks)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "client-requisitions/create"))
	}
}

export const externalwarehousingCostsAPI = {
	clean:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/externalwarehousingCosts/clean')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "externalwarehousingCosts/clean"))
	},
	create:(externalwarehousingCost, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/externalwarehousingCosts', externalwarehousingCost)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "externalwarehousingCosts/create"))
	},
	update:(wcid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/externalwarehousingCosts/'+wcid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "externalwarehousingCosts/update"))
	},
	delete:(wcid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.delete('/externalwarehousingCosts/'+wcid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "externalwarehousingCosts/create"))
	},
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/externalwarehousingCosts')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "externalwarehousingCosts/list"))
	},
}

export const guidesAPI = {
	refresh:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/guides/refresh')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "guides/refresh"))
	},
	clean:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/guides/clean')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "guides/clean"))
	},
	create:(guide, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/guides', guide)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "guides/create"))
	},
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/guides')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "guides/list"))
	},
}

export const stockCostsAPI = {
	clean:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/stockCosts/clean')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stockCosts/clean"))
	},
	create:(stockCost, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/stockCosts', stockCost)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stockCosts/create"))
	},
	update:(scid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/stockCosts/'+scid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stockCosts/update"))
	},
	delete:(scid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.delete('/stockCosts/'+scid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stockCosts/create"))
	},
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/stockCosts')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "stockCosts/list"))
	},
}

export const extraCostsAPI = {
	clean:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/extraCosts/clean')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "extraCosts/clean"))
	},
	create:(extraCost, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/extraCosts', extraCost)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "extraCosts/create"))
	},
	update:(pcid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/extraCosts/'+pcid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "extraCosts/update"))
	},
	delete:(pcid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.delete('/extraCosts/'+pcid)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "extraCosts/create"))
	},
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/extraCosts')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "extraCosts/list"))
	},
}

export const publicityCampaignsAPI = {
	clean:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/publicityCampaigns/clean')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "publicityCampaigns/clean"))
	},
	create:(extraCost, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/publicityCampaigns', extraCost)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "publicityCampaigns/create"))
	},
	update:(pcid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/publicityCampaigns/'+pcid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "publicityCampaigns/update"))
	},
	delete:(pcids, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.delete('/publicityCampaigns/'+pcids.join(","))
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "publicityCampaigns/create"))
	},
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/publicityCampaigns')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "publicityCampaigns/list"))
	},
	bulkCreate:(publicityCampaigns, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/publicityCampaigns/bulk', publicityCampaigns)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "publicityCampaigns/bulk"))
	},
}

export const productPublicitiesAPI = {
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/productPublicities')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "productPublicities/list"))
	},
	bulkCreate:(productPublicities, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/productPublicities/bulk', productPublicities)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "productPublicities/bulk"))
	},
}

export const eventsAPI = {
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/events')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "events/list"))
	},
}

export const groupedSalesAPI = {
	create:(guide, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.post('/platform/groupedSales', guide)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "groupedSales/create"))
	},
	update:(gsid, body, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.put('/platform/groupedSales/'+gsid, body)
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "groupedSales/update"))
	},
	remove:(gsid, callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.delete('/platform/groupedSales/'+gsid)
			.then(r => callback())
			.catch(e => handleError(e, error, "groupedSales/remove"))
	},
	list:(callback, error = defaultError) => {
		axios.token({token: window.localStorage.getItem(config.tokenName), session: window.localStorage.getItem(config.sessionName), store: window.localStorage.getItem(config.storeName)})
			.get('/platform/groupedSales')
			.then(r => callback(r.data))
			.catch(e => handleError(e, error, "groupedSales/list"))
	},
}